module.exports = __webpack_public_path__ + "static/home1-header-center-6e5eb9c0cecccdc6462610073d99ae2e.png";